import { memo } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName, setPropTypes } from 'recompact';
import { defaultMemoize } from 'reselect';

import { chooseFlavor, errorBoundary, withClient, withLoading } from 'src/app/hocs';
import type { DeliveryWindow as DeliveryWindowType } from 'src/app/types';
import { formatDeliveryWindowTimeRange, formatDeliveryWindowTimeRangeWithDay } from 'src/app/utils';

import RendererForCheckout from './checkout';

import { DeliveryWindow } from '.';

type ComputeTimeRange = (deliveryWindow: DeliveryWindowType, hasWithDay: boolean) => string | [string, string];
export const computeTimeRange: ComputeTimeRange = defaultMemoize((deliveryWindow, hasWithDay) => {
  const { startDate, endDate, category, facilityTimezone } = deliveryWindow || {};
  if (hasWithDay) {
    return formatDeliveryWindowTimeRangeWithDay(startDate, endDate, facilityTimezone);
  }
  return formatDeliveryWindowTimeRange(startDate, endDate, category, facilityTimezone);
});

function makeMapStateToProps() {
  return (state, ownProps) => {
    const { deliveryWindow, withDay } = ownProps;
    const timeRange =
      withDay !== undefined ? computeTimeRange(deliveryWindow, true) : computeTimeRange(deliveryWindow, false);
    return {
      deliveryWindow,
      timeRange,
      isLoading: !deliveryWindow,
    };
  };
}

export default compose(
  setDisplayName('DeliveryWindow'),
  errorBoundary,
  setPropTypes({
    isActive: PropTypes.bool,
    withDay: PropTypes.bool,
  }),
  withClient,
  connect(makeMapStateToProps),
  memo,
  withLoading
)(
  chooseFlavor({
    default: DeliveryWindow,
    checkout: RendererForCheckout,
  })
);
